import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';

import {
  routing,
  appRoutingProviders
} from './app.routing';

import { WBModule } from './wb/wb.module';
//import { Ng2BootstrapModule } from 'ng2-bootstrap/ng2-bootstrap';
import { HttpModule, Http } from '@angular/http';
import { ModalModule } from "ng2-modal";
import { TranslateModule, TranslateStaticLoader, TranslateLoader } from 'ng2-translate/ng2-translate';
import { SessionManagerService } from './wb/services/session/session-manager.service';
import { SessionParserService } from './wb/services/session/session-parser.service';
import { RecordingManagerService } from './wb/services/recording/recording-manager.service';
import { RecordingParserService } from './wb/services/recording/recording-parser.service';
import { UserTypeManagerService, UserType } from './wb/services/usertype/user-type-manager.service';
import { WsService2 } from './wb/services/ws/ws.service';
import { UserTypeParserService } from './wb/services/usertype/user-type-parser.service';
import { LayoutParserService } from './wb/services/layout/layout-parser.service';
import { LayoutManagerService } from './wb/services/layout/layout-manager.service';
import { RoomParserService } from './wb/services/room/room-parser.service';
import { RoomManagerService } from './wb/services/room/room-manager.service';
import { MediaParserService } from './wb/services/media/media-parser.service';
import { MediaManagerService } from './wb/services/media/media-manager.service';
import {ReplayerService} from './wb/player/replayer.service';
import { ContentParserService } from './wb/services/content/content-parser.service';
import { NetworkService } from './wb/player/network.service';
import { WsService } from './utils/network/ws.service';
import { MediaService } from './wb/peers/media.service';
import { PermissionsManagerService } from './wb/services/permissions/permissions-manager.service';
import { PermissionsParserService } from './wb/services/permissions/permissions-parser.service';
import { LogService } from './wb/services/log/log.service';

import { WbService } from './wb/wb.service';

import {DesksService} from './wb/desksmenu/desks.service';

export function HttpLoaderFactory(http: Http) {
   return new TranslateStaticLoader(http, 'assets/i18n/', '.json');
}
@NgModule({
  imports: [BrowserModule, routing, WBModule, ModalModule, HttpModule, 
  
  TranslateModule.forRoot({
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [Http]
  })],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    appRoutingProviders

  ], 
})
export class AppModule { }


// WEBPACK FOOTER //
// /app/src/app/app.module.ts